<div class="c-template-container"
  [ngClass]="[
    'c-template-container--padding-' + padding,
    fullHeight ? 'c-template-container--full-height' : '',
  ]">
  <ng-content></ng-content>
</div>
